import { render, staticRenderFns } from "./popup-layer.vue?vue&type=template&id=27adaff1&"
import script from "./popup-layer.vue?vue&type=script&lang=js&"
export * from "./popup-layer.vue?vue&type=script&lang=js&"
import style0 from "./popup-layer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27adaff1')) {
      api.createRecord('27adaff1', component.options)
    } else {
      api.reload('27adaff1', component.options)
    }
    module.hot.accept("./popup-layer.vue?vue&type=template&id=27adaff1&", function () {
      api.rerender('27adaff1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup-layer/popup-layer.vue"
export default component.exports